import { render } from "./ArticleModalInfoBox.vue?vue&type=template&id=7119c8d6&scoped=true"
import script from "./ArticleModalInfoBox.vue?vue&type=script&lang=js"
export * from "./ArticleModalInfoBox.vue?vue&type=script&lang=js"

import "./ArticleModalInfoBox.vue?vue&type=style&index=0&id=7119c8d6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7119c8d6"]])

export default __exports__